import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const AuthenticCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Autentiche',
    path: '/sportello/autentiche',
  },
];
